import angular from 'angular';

class modalMissingDocumentModelAttributeCtrl {

  close() {
    this.modalInstance.dismiss(this.data);
  }

  $onInit() {
    this.models = angular.copy(this.resolve.models);
  }
}

angular.module('app.principal').component('modalMissingDocumentModelAttribute', {
  templateUrl: require('./modal-missing-documentmodel-attributes.html'),
  controller: modalMissingDocumentModelAttributeCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
